import React from 'react'
import _ from 'lodash'
import { component_tool } from "@/tool";
import { WizClassifySelect, WizAuthority, WizTableForm } from '@/containers/common';

const { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
const componentName = "examTemplateRelation";
const validator = (rule, value, callback) => {
  if (value) {
    if (value.positionIds && value.positionIds.length) {
      callback()
      return
    }
  }
  callback('请选择岗位')
}

const columns = (examTemplateId) => {
  const examTemp = WizTableForm.Config.examTemp(this, { apiParams: { state: 1, type: examTemplateId } })
  const position = WizTableForm.Config.position(this, { apiParams: { state: 1, type: examTemplateId } })
  return [
    {
      name: "id",
      dataIndex: "id",
      formItem: {
        type: "hidden"
      },
    },
    {
      title: "考试模版名称",
      name: "examTemplateTitle",
      dataIndex: "examTemplateTitle",
      searchItem: {},
      tableItem: {
        width: 300
      },
      formItem: {
        type: "hidden"
      },
    },
    {
      title: "岗位对象",
      name: "authInfo",
      tableItem: {
        width: 500,
        type: 'custom',
        render: (record, form) => {
          let authInfoName = ""
          if (record && record['positionIds'] && record['positionIds'] instanceof Array && record['positionIds'].length > 0) {
            let list = _.orderBy(record['positionIds'], ['id'], ['asc']);
            authInfoName = list.map(p => p.positionBrandName).join(",")
          }
          return (
            <div>
              {authInfoName}
            </div>)
        },
      },
    },
    {
      title: "模版名称",
      name: "examTemplate",
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          return (
            <>
              {getFieldDecorator('examTemplate', {
                rules: [
                  {
                    required: true,
                    message: '请选择模版'
                  }
                ],
                initialValue: record&&record.examTemplateId ||null,
              })(
                <WizTableForm
                  key={'user'}
                  {...examTemp}
                  selectType={'radio'}
                  initRows={ record&&record.examTemplateId ? [{ id: record.examTemplateId, title: record.examTemplateTitle }] : []}
                />
              )}
            </>
          )
        }

      }
    },
    {
      title: "岗位对象",
      name: "authInfo",
      formItem: {
        type: 'diy',
        diy: WizAuthority,
        rules: [{ required: true, validator }],
        showBlock: false,
        visible: false,
        mode: 'Form',
        keys: ['positionIds'],
        hasRadioGroup: false,
        keyConfig: { positionIds: { title: '', config: position } },
        formPropsExtra: {
          formItemLayout: {
            labelCol: { span: 4 },
            wrapperCol: { span: 24 }
          },
        }
      },
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 1, codeName: "有效" },
        { code: 0, codeName: "无效" },
      ],
      searchItem: {
        type: "select",
      },
      formItem: {
        type: "radio",
        initialValue: 0
      },
      tableItem: {
        width: 100
      },
    },

  ];
}

const templateConfig = (examTemplateGroupId) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(examTemplateGroupId),
        searchBarProps: {
          buttonSort: ['add','delete'],
          buttons: [
          ],
        },
        rowOperateSort: ['update',  'enableOrDisable'],
        rowOperateView: [
          {
            key: "enableOrDisable",
            custom: true,
            params: { children: "启用"},
            textFormat: {
              recordKey: "status",
              dirt: { 1: "禁用", 0: "启用" },
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
              },
              formatParams: (rows, record, filters, callback) => {
                const content =
                  "您确定要" +
                  (record.status === 1 ? "禁用" : "启用") +
                  "该考试模版组吗?";
                WizModal.confirm({
                  title: "注意",
                  content,
                  onOk: () => {
                    callback &&
                      callback({
                        status: record.status === 1 ? 0 : 1,
                        id: record.id,
                        ...filters
                      });
                  },
                  onCancel() { },
                });
                return null;
              },
            },
          },
        ],
        modalFormProps: {
          dataFormat:(v)=>{
            v['examTemplateId'] = v['examTemplate']&& v['examTemplate'] || null
            v['entityId'] = examTemplateGroupId
            v['entityType'] = 1
            v['positionIds'] = v['authInfo']&& v['authInfo']['positionIds']&& v['authInfo']['positionIds'].map(p=>p['id']) || []
            v['examTemplate'] = null
            return v
          },},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        commonOperate: {
        },
      },
    },
  };
}

const apis = (entityId) => {
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@list`,
        apiParams: { pageNum: 1, pageSize: 10, entityId },
      },
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {},
      },
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
      }
    },
  };
}

let reduxTemplateConfig = (args) => {
  const { examTemplateGroupId } = args
  return {
    apis: apis(examTemplateGroupId),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    keepInitApiParams: true,
    ...args,
  };
};

export { reduxTemplateConfig, templateConfig };
